import { isly } from "isly";
import { system } from "../../system";
export var Numeric;
(function (Numeric) {
    var _a;
    Numeric.values = [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
        32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53,
    ];
    _a = isly
        .number("value", ...Numeric.values)
        .rename("isoly.Week.Number.Numeric")
        .bind(), Numeric.type = _a.type, Numeric.is = _a.is, Numeric.flawed = _a.flawed;
    function parse(value) {
        return Numeric.type.get(system.Number.parseInt(value));
    }
    Numeric.parse = parse;
})(Numeric || (Numeric = {}));
//# sourceMappingURL=Numeric.js.map